import moment from 'moment';

export default {

  // 获取星期几
  getWeekDay(dateStr) {
    return `星期${'日一二三四五六'.charAt(new Date(dateStr).getDay())}`;
  },

  // 获取基本日期,例如 2018-01-01
  getBaseDate(date, unit = '-') {
    if (typeof date === 'string') date = new Date(date);
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    if (month < 10) {
      month = `0${month}`;
    }
    if (day < 10) {
      day = `0${day}`;
    }
    return `${year}${unit}${month}${unit}${day}`;
  },

  // 获取日期小时和分钟
  getDateMinAndHour(date) {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    if (hours < 10) {
      hours = `0${hours}`;
    }
    if (minutes < 10) {
      minutes = `0${minutes}`;
    }
    return `${hours}:${minutes}`;
  },

  // 格式化日期，将2017-09-01格式化为9月1日
  formatDateWithoutYear(date) {
    let newDate = '';
    if (!date) {
      newDate = new Date();
    } else {
      // 解决 IE 兼容性问题。IE new Date() 无法转换带"-"的时间
      date = date.replace(/-/g, '/');
      newDate = new Date(date);
    }
    const dateString = `${newDate.getMonth() + 1}月${newDate.getDate()}日`;
    return dateString;
  },
  // 格式化日期，将2017-09-01,2017-09-05格式化为9月1日-9月5日
  formatDateWithConcat(date) {
    let newDate = '';
    let newDate2 = '';
    let dateString = '';
    let tempDate = '';
    if (!date) {
      newDate = new Date();
    } else if (date.indexOf(',') > -1) {
      newDate = new Date(date.split(',')[0]);
      newDate2 = new Date(date.split(',')[1]);
      if (newDate > newDate2) {
        tempDate = newDate;
        newDate = newDate2;
        newDate2 = tempDate;
      }
      dateString = `${newDate.getMonth() + 1}月${newDate.getDate()}日-${newDate2.getMonth() + 1}月${newDate2.getDate()}日`;
    } else {
      newDate = new Date(date);
      dateString = `${newDate.getMonth() + 1}月${newDate.getDate()}日`;
    }
    return dateString;
  },
  // 格式化日期，将2017-09-08格式化为9月8日 星期三
  formatDateWithWeek(date) {
    let newDate = '';
    if (!date) {
      newDate = new Date();
    } else {
      newDate = new Date(date);
    }
    const weekday = { 0: '星期日', 1: '星期一', 2: '星期二', 3: '星期三', 4: '星期四', 5: '星期五', 6: '星期六' };
    const dateString = `${newDate.getMonth() + 1}月${newDate.getDate()}日 ${weekday[newDate.getDay()]}`;
    return dateString;
  },
  // 格式化日期，将2017-09-08格式化为09月08日 星期三
  formatDateWithzeroWithWeek(date) {
    let newDate = '';
    if (!date) {
      newDate = new Date();
    } else {
      newDate = new Date(date);
    }
    const weekday = { 0: '星期日', 1: '星期一', 2: '星期二', 3: '星期三', 4: '星期四', 5: '星期五', 6: '星期六' };
    const month = (newDate.getMonth() + 1) < 10 ? `0${newDate.getMonth() + 1}` : newDate.getMonth() + 1;
    const day = newDate.getDate() < 10 ? `0${newDate.getDate()}` : newDate.getDate();
    const year = newDate.getFullYear();
    const dateString = `${year}年${month}月${day}日 ${weekday[newDate.getDay()]}`;
    return dateString;
  },
  // 格式化日期，将2017-09-08格式化为09月08日
  formatDateWithzeroWithOutWeek(date) {
    let newDate = '';
    if (!date) {
      newDate = new Date();
    } else {
      newDate = new Date(date);
    }
    const month = (newDate.getMonth() + 1) < 10 ? `0${newDate.getMonth() + 1}` : newDate.getMonth() + 1;
    const day = newDate.getDate() < 10 ? `0${newDate.getDate()}` : newDate.getDate();
    const year = newDate.getFullYear();
    const dateString = `${year}年${month}月${day}日`;
    return dateString;
  },
  // 将连续日期组合成2017-09-10，2017-09-15
  concatDate(dateArr) {
    const newArr = [];
    let beginTime = '1970-01-01';
    let endTime = '1970-01-01';

    if (dateArr.length === 0) {
      return [];
    }

    // 遍历传入的日期数组
    dateArr.forEach((time, index) => {
      let beginObj = new Date(beginTime);
      let endObj = new Date(endTime);
      const timeObj = new Date(time);

      // 当index为0时初始化开始日期结束日期
      if (index === 0) {
        beginObj = new Date(time);
        endObj = new Date(time);
        beginTime = time;
        endTime = time;
      }

      // 若数组只有一个元素，直接存入
      if (index === 0 && dateArr.length === 1) {
        newArr.push(beginTime);
      } else if (timeObj - endObj <= 86400000 && (index + 1 === dateArr.length)) {
        // 若是数组的最后一个元素，且跟上一个元素相差一天以内，更新结束日期，存入日期段
        endTime = time;
        newArr.push(`${beginTime},${endTime}`);
      } else if (timeObj - endObj <= 86400000) {
        // 若当前元素与上一个元素相差一天以内，仅更新结束日期
        endTime = time;
      } else if (timeObj - endObj > 86400000 && (index + 1 === dateArr.length) && endObj - beginObj > 0) {
        //  若当前元素与上一个元素相差大于一天，且是数组最后一个元素，且上一个日期段已结束，先存入上一个时间段，再存入最后一个日期
        newArr.push(`${beginTime},${endTime}`);
        newArr.push(time);
      } else if (timeObj - endObj > 86400000 && (index + 1 === dateArr.length)) {
        //  若当前元素与上一个元素相差大于一天，且是数组最后一个元素，先存入前一个日期，然后存入最后一个日期
        newArr.push(endTime);
        newArr.push(time);
      } else if (timeObj - endObj > 86400000 && endObj - beginObj === 0) {
        // 若当前元素与上一个元素相差大于一天，但是上个元素是单独的，那么直接存入单个日期，并更新开始日期和结束日期
        newArr.push(endTime);
        beginTime = time;
        endTime = time;
      } else if (timeObj - endObj > 86400000) {
        // 若当前元素与上一个元素相差大于一天，存入上个连续日期段，并更新开始日期和结束日期
        newArr.push(`${beginTime},${endTime}`);
        beginTime = time;
        endTime = time;
      }
    });
    return newArr;
  },

  getNextNDate(date, n) {
    return new Date(+date + 86400000 * n);
  },

  _getClosestDate(minDay, condition = () => { }, naturalDay = 0) {
    const self = this;
    let date = self.getNextNDate(new Date(), naturalDay);
    let timestamp = +date;
    let dateString = date.format('yyyy-MM-dd');
    let dayUnit = minDay;
    while (dayUnit) {
      date = new Date(timestamp + 86400000);
      timestamp = +date;
      dateString = date.format('yyyy-MM-dd');
      if (condition(dateString, date)) {
        dayUnit -= 1;
      }
    }
    return date;
  },

  getClosestDate(minDay, holiday = [], naturalDay) {
    const self = this;
    return self._getClosestDate(minDay, dateString => holiday.indexOf(dateString) === -1, naturalDay);
  },

  /*
    * 赴馆通知书 转换日期格式
    * */
  dateChange(time) {
    /* eslint-disable prefer-const */
    let [date, subTime] = time.replace(/-/g, '/').split(' ');
    subTime = subTime.split(':').slice(0, 2).join(':');
    return `${this.formatDateWithzeroWithWeek(date)} ${subTime}`;
  },

  // 设置需要显示的日期的条件
  setNeedReturnDay(date, dateArr, index) {
    let isNeedReturnDay = false;
    const dateDay = new Date(date).getDay();
    if (dateDay !== 0 && dateDay !== 6) {

      // 如果是工作日一定需要
      isNeedReturnDay = true;

    } else if (dateDay === 6) {

      // 如果为周六
      // 看后两天是不是周一
      // 或者看前一天是不是周五
      const preDay = dateArr[index - 1];
      const lastTwoDay = dateArr[index + 2];
      const nowDateTime = new Date(date).getTime();
      if (
        (new Date(lastTwoDay).getDay() === 1 && new Date(lastTwoDay).getTime() - nowDateTime === 2 * 24 * 60 * 60 * 1000) ||
        (new Date(preDay).getDay() === 5 && nowDateTime - new Date(preDay).getTime() === 1 * 24 * 60 * 60 * 1000)
      ) {
        isNeedReturnDay = true;
      }

    } else if (dateDay === 0) {

      // 如果为周天
      // 看后一天是不是周一
      // 或者看前两天是不是周五
      const preTwoDay = dateArr[index - 2];
      const lastDay = dateArr[index + 1];
      const nowDateTime = new Date(date).getTime();
      if (
        (new Date(lastDay).getDay() === 1 && new Date(lastDay).getTime() - nowDateTime === 1 * 24 * 60 * 60 * 1000) ||
        (new Date(preTwoDay).getDay() === 5 && nowDateTime - new Date(preTwoDay).getTime() === 2 * 24 * 60 * 60 * 1000)
      ) {
        isNeedReturnDay = true;
      }

    }
    return isNeedReturnDay;
  },
  formatDate(str, formatStr = 'YYYY-MM-DD') {
    return moment(str).format(formatStr);
  },

  getDateDayDiff(start, end) {
    if (!start || !end) return 0;
    // 获取到开始和结束的日期，去除时间
    const startDate = this.formatDate(start, 'YYYY/MM/DD');
    const endDate = this.formatDate(end, 'YYYY/MM/DD');

    const startTime = new Date(startDate).getTime();
    const endTime = new Date(endDate).getTime();
    const diffDay = parseInt((endTime - startTime) / (24 * 60 * 60 * 1000), 10);
    return diffDay;
  },
};



// WEBPACK FOOTER //
// ./src/libs/date-util.js